import { Container } from './styles'

interface TooltipProps {
  title: string
  className?: string
}

const Tooltip: React.FC<TooltipProps> = ({ title, children, className }) => {
  return (
    <Container className={className}>
      {children}
      <span dangerouslySetInnerHTML={{ __html: title }} />
    </Container>
  )
}

export default Tooltip
